<div>
  <div class="row">
    <div class="col-md-12">
      <app-components-specialist-actioncomponents-customer-information
        [customer]="customer"
        [parentTaskId]="parentTaskId">
      </app-components-specialist-actioncomponents-customer-information>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-components-specialist-actioncomponents-seo-content-survey
        [customerId]="customer.CustomerId">
      </app-components-specialist-actioncomponents-seo-content-survey>
    </div>
  </div>
</div>